import { render, staticRenderFns } from "./datalive3.vue?vue&type=template&id=5dc0d076&scoped=true&"
import script from "./datalive3.vue?vue&type=script&lang=js&"
export * from "./datalive3.vue?vue&type=script&lang=js&"
import style0 from "./datalive3.vue?vue&type=style&index=0&id=5dc0d076&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc0d076",
  null
  
)

export default component.exports